/**
 * `sequences` — la numérotation de la galerie (base galerie, 4.1 ; 7.6).
 *
 * Une séquence par galerie et, pour les documents, par année : continue, sans
 * trou. Le formatage et l'analyse des numéros sont dans `../sequences.ts`.
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const CLES_SEQUENCE = ['inventaire', 'facture', 'avoir', 'certificat', 'offre'];
export const cleSequenceSchema = z.enum(CLES_SEQUENCE);
export const sequenceSchema = withAudit(z.object({
    _id: idSchema,
    cle: cleSequenceSchema,
    /** Motif du numéro : « SAV-{AAAA}-{0000} », « F-{AAAA}-{0000} ». */
    motif: z.string().min(1),
    /** Année de la séquence, quand elle repart à zéro chaque année. */
    annee: z.int().min(1900).max(2999).optional(),
    /** Portée supplémentaire : l'identifiant de l'artiste, pour `{ARTISTE}`. */
    portee: z.string().optional(),
    dernier: z.int().min(0).default(0),
    remiseAZeroAnnuelle: z.boolean().default(true),
}));
export const sequenceCreationSchema = sequenceSchema.omit({ ...CHAMPS_DOCUMENT, dernier: true });
export const sequenceMiseAJourSchema = sequenceCreationSchema.omit({ cle: true }).partial();
//# sourceMappingURL=sequences.js.map